import React from 'react';
import Icon from '../../../components/AppIcon';

const RatingsBreakdown = ({ profile, completedCount, currentLanguage }) => {
  const translations = {
    en: {
      title: 'Ratings Breakdown',
      communication: 'Communication',
      reliability: 'Reliability',
      itemCondition: 'Item Condition',
      completedDeliveries: 'Completed Deliveries',
      successRate: 'Success Rate'
    },
    ko: {
      title: '평점 세부사항',
      communication: '의사소통',
      reliability: '신뢰성',
      itemCondition: '물품 상태',
      completedDeliveries: '완료된 배송',
      successRate: '성공률'
    }
  };

  const t = translations?.[currentLanguage];

  // Simulate category ratings based on overall rating
  const baseRating = profile?.rating || 0;
  const categories = [
    {
      label: t?.communication,
      rating: Math.min(5, baseRating + 0.2),
      icon: 'MessageSquare',
      color: 'var(--color-primary)'
    },
    {
      label: t?.reliability,
      rating: Math.min(5, baseRating + 0.1),
      icon: 'Shield',
      color: 'var(--color-success)'
    },
    {
      label: t?.itemCondition,
      rating: Math.min(5, baseRating - 0.1),
      icon: 'Package',
      color: 'var(--color-warning)'
    }
  ];

  const successRate = completedCount > 0 ? 98 : 0;

  return (
    <div className="bg-card rounded-lg shadow-elevation-md overflow-hidden h-full">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-warning/10 rounded-lg flex items-center justify-center">
            <Icon name="Star" size={20} color="var(--color-warning)" />
          </div>
          <h2 className="text-xl font-heading font-semibold text-foreground">
            {t?.title}
          </h2>
        </div>
      </div>

      <div className="p-4 md:p-6 space-y-6">
        {/* Category Ratings */}
        {categories?.map((category, index) => (
          <div key={index}>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <Icon name={category?.icon} size={16} color={category?.color} />
                <span className="text-sm font-medium text-foreground">{category?.label}</span>
              </div>
              <span className="text-sm font-semibold text-foreground">
                {category?.rating?.toFixed(1)}
              </span>
            </div>
            <div className="w-full bg-muted/30 rounded-full h-2">
              <div
                className="h-2 rounded-full transition-all duration-300"
                style={{
                  width: `${(category?.rating / 5) * 100}%`,
                  backgroundColor: category?.color
                }}
              />
            </div>
          </div>
        ))}

        {/* Performance Metrics */}
        <div className="pt-4 border-t border-border space-y-3">
          <div className="flex items-center justify-between p-3 bg-muted/20 rounded-lg">
            <div className="flex items-center gap-2">
              <Icon name="CheckCircle" size={16} color="var(--color-success)" />
              <span className="text-sm text-muted-foreground">{t?.completedDeliveries}</span>
            </div>
            <span className="text-lg font-semibold text-foreground">{completedCount}</span>
          </div>

          <div className="flex items-center justify-between p-3 bg-muted/20 rounded-lg">
            <div className="flex items-center gap-2">
              <Icon name="TrendingUp" size={16} color="var(--color-primary)" />
              <span className="text-sm text-muted-foreground">{t?.successRate}</span>
            </div>
            <span className="text-lg font-semibold text-foreground">{successRate}%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RatingsBreakdown;